import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, ButtonBase, Chip, CircularProgress, Typography, useTheme, } from "@mui/material";
import { InvitationTypeEnum } from "@application/common/enums/invitation-type-enum";
import FilterHeading from "./chipContent/FilterHeading";
const SearchResult = ({ closePopover, data, isFetching, }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const handleClickInvitation = ({ eventId, invitationId, invitationType, eventType, isArchived, }) => {
        closePopover();
        navigate(`/admin/invitation`, {
            state: {
                targetEventId: eventId,
                targetInvitationId: invitationId,
                targetInvitationType: invitationType,
                targetEventType: eventType,
                fromSearch: true, // Add a flag to identify search navigation
                targetTab: isArchived ? "archived" : "active",
            },
            replace: true, // Use replace to prevent adding to history stack
        });
    };
    const calcItemContainerMaxHeight = useMemo(() => {
        if (Array.isArray(data)) {
            if (data.length === 1) {
                // if we only have one eventType ie familiefeest or relationsDay
                if (data[0]?.eventType === 1) {
                    // familiefeest
                    return "500px";
                }
                if (data[0]?.eventType === 2 &&
                    Array.isArray(data[0]?.eventWiseInformation)) {
                    // in case of relationsDay check if it has eventWiseInformation, an array that contains internals and externals data
                    if (data[0].eventWiseInformation.length === 1) {
                        // if one of the two is present, we return 500px
                        return "500px";
                    }
                    if (data[0].eventWiseInformation.length === 2) {
                        // if both are present, we return 300px
                        return "300px";
                    }
                }
            }
            if (data.length === 2) {
                // if we have both familiefeest and relationsDay
                const eventType2Obj = data.find((item) => item.eventType === 2);
                if (
                // Scenario: familiefeest exists but relationsDay has only one eventWiseInformation
                eventType2Obj &&
                    Array.isArray(eventType2Obj.eventWiseInformation) &&
                    eventType2Obj.eventWiseInformation.length === 1) {
                    return "300px";
                }
            }
        }
        return "143px"; // Default height for other cases i.e all 3 categories are present
    }, [data]);
    return (_jsx(_Fragment, { children: _jsx(Box, { sx: {
                height: "auto",
                maxHeight: "100dvh",
                display: "flex",
                flexDirection: "column",
            }, children: isFetching ? (_jsx(Box, { display: "flex", justifyContent: "center", alignItems: "center", height: "200px", children: _jsx(CircularProgress, {}) })) : !data || data.length < 1 ? (_jsx(_Fragment, { children: _jsx(Box, { display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", paddingY: "20px", children: _jsx(Typography, { variant: "subtitle2", children: t("common.noRecordFound") }) }) })) : (_jsx(Box, { sx: { flex: 1, padding: 2 }, children: data &&
                    data.map(({ eventName, eventWiseInformation, eventType }, index) => (_jsxs(React.Fragment, { children: [_jsx(FilterHeading, { heading: `${eventType === 1 ? (eventWiseInformation[0]?.totalCount ?? 0) : ""} ${eventName}`, isShowViewAll: false }), eventWiseInformation.map(({ invitationType, invitationTypeWiseInformation, totalCount, }) => (_jsxs(React.Fragment, { children: [invitationType !== InvitationTypeEnum.Family && (_jsx(FilterHeading, { heading: `${totalCount ?? 0}
                                ${invitationType === InvitationTypeEnum.External
                                            ? "Extern"
                                            : "Intern"}`, isShowViewAll: false })), _jsx(Box, { sx: {
                                            maxHeight: calcItemContainerMaxHeight,
                                            height: "100%",
                                            overflowY: "auto",
                                            p: "8px 16px",
                                        }, children: invitationTypeWiseInformation.map(({ fullName, companyName, status, invitationId, isArchived, }) => (_jsx(Box, { children: _jsx(ButtonBase, { onClick: () => handleClickInvitation({
                                                    invitationId,
                                                    eventId: data[index].eventId,
                                                    invitationType,
                                                    eventType: data[index].eventType,
                                                    isArchived,
                                                }), sx: {
                                                    width: "100%",
                                                    textAlign: "left",
                                                    borderRadius: "12px",
                                                }, children: _jsxs(Box, { display: "flex", flexDirection: "column", padding: "8px 12px", boxShadow: theme.shadows[4], width: "100%", marginBottom: 1, borderRadius: "12px", children: [_jsxs(Box, { display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%", alignItems: "center", gap: 2, children: [_jsx(Typography, { variant: "body2", color: theme.palette.text.primary, dangerouslySetInnerHTML: {
                                                                        __html: fullName,
                                                                    } }), isArchived && (_jsx(Chip, { label: t("admin.archived"), variant: "outlined", color: "info", size: "small" }))] }), _jsx(Box, { display: "flex", flexDirection: "row", alignItems: "center", gap: 1, width: "100%", mt: 0.5, children: _jsx(Typography, { variant: "caption", color: theme.palette.text.secondary, children: companyName }) })] }, 1) }, 1) }, invitationId))) })] }, `invitationType-${invitationType}`)))] }, `${eventName}-${index}`))) })) }) }));
};
export default SearchResult;
